module.exports = __webpack_public_path__ + "img/3.21e5c1df.png";